export default __webpack_public_path__ + "assets/images/bitcointalk-e5eb9e89fc4ed01c7b2b607834503068.svg";